<div class="container">

  <div class="message-box">
    <h1 class="message-box__title">{{title | translate}}</h1>
    <p class="message-box__message" [innerHtml]="message | translate"></p>
  </div>

</div>
